function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 24a.5.5 0 010-1h3.622L7.985 9.331l1.077-3.814V5.5a.49.49 0 01.08-.266l1.104-3.908A1.83 1.83 0 0112 0a1.8 1.8 0 011.725 1.305L19.878 23H23.5a.5.5 0 010 1H.5zm18.338-1l-1.134-4H6.291l-1.13 4h13.677zm-1.418-5l-.851-3H7.422l-.848 3H17.42zm-1.134-4l-1.134-4H8.835l-1.13 4h8.581zm-1.418-5l-.851-3H9.965l-.848 3h5.751zm-1.134-4l-.971-3.422A.797.797 0 0012 1a.826.826 0 00-.791.598L10.248 5h3.486z"
});

function SvgMdConstraintGeneric(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "mdConstraintGeneric.786e6.svg";
export { SvgMdConstraintGeneric as ReactComponent };